(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') {
      var form = document.querySelector('.contact-form__form');
      var success = document.querySelector('.contact-form__success');
      if (form) form.style.display = 'none';
      if (success) {
        success.removeAttribute('style');
        success.style.display = 'flex';
        success.scrollIntoView({ behavior: 'smooth' });
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
